/**
 * theme.js — Theme Blueprint
 * ---------------------------------------------------------------------------
 * Global JS entry point. Kept intentionally minimal for the skeleton stage.
 * Behaviour will be added as small, progressively-enhanced modules (ideally
 * as custom elements, in the spirit of Shopify's Dawn) once the Liquid layer
 * is built.
 */

(() => {
  "use strict";

  // Flag that JS is available so CSS can enhance accordingly.
  document.documentElement.classList.remove("no-js");
  document.documentElement.classList.add("js");

  // Cookie settings (footer legal row): open Shopify's own consent
  // preferences dialog. window.privacyBanner is injected by Shopify while
  // the cookie banner is enabled; loadFeatures is the fallback path for
  // pages where it has not been set up yet.
  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-cookie-settings]");
    if (!btn) return;
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === "function") {
      window.privacyBanner.showPreferences();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        function () {
          if (window.privacyBanner && typeof window.privacyBanner.showPreferences === "function") {
            window.privacyBanner.showPreferences();
          }
        }
      );
    }
  });
})();
